import {
  Component,
  inject,
  OnInit,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
} from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { AlertService } from '../../services/alert.service';
import { MdlCall } from '../../components/mdl-call/mdl-call';
import { MdlTask } from '../../components/mdl-task/mdl-task';
import { MdlEvent } from '../../components/mdl-event/mdl-event';
import { MdlManageProspect } from '../../components/mdl-manage-prospect/mdl-manage-prospect';
import { CommonModule } from '@angular/common';
import { MdlChangeOwnerComponent } from '../../components/mdl-change-owner/mdl-change-owner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute, Router } from '@angular/router';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { Mdlfilterectivities } from '../../components/mdl-filter-activities/mdl-filter-activities';
import { NavOpportunities } from '../../components/opportunities/nav-opportunities/nav-opportunities';
import { MdlManageOportunity } from '../../components/mdl-manage-opportunity/mdl-manage-opportunity';
import { MdlSelectCompanyType } from '../../components/mdl-public-private/mdl-public-private';
import { FormsModule } from '@angular/forms';
import { OpportunitiesGeneral } from '../opportunities-generalview-table/opportunities-generalview-table';
import { MdlManageGoals } from '../../components/mdl-manage-goals/mdl-manage-goals';
import { MdlFilterGoals } from '../../components/mdl-filter-goals/mdl-filter-goals';
import { PermissionService } from '../../services/permission.service';
import { MontoInteligentePipe } from '../../services/montoInteligente.pipe';

@Component({
  selector: 'app-nav-stagehistory',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    FormsModule,
    MatDialogModule,
    MontoInteligentePipe
  ],
  templateUrl: './goals.html',
  styleUrl: './goals.css',
})
export class Goalstable {
  dashboardData = {
    metasEncurso: 0,
    cumplimiento: 0,
    totalAlcanzado: 0,
    completadas: 0,
  };

  hoverCard: string = '';

  ngOnInit(): void {
    this.api.getmetasDashboard().subscribe({
      next: (data: any) => {
        this.dashboardData = data;
        this.cambiosPorUsuario = data.cambiosPorUsuario || {};
      },
      error: (err: any) => {
        console.error('Error al cargar datos del dashboard:', err);
      },
    });
    this.api.getUsers().subscribe({
      next: (res: any) => {
        this.usuarios = res.users || [];
        console.log('Usuarios cargados:', this.usuarios);
      },
      error: (err: any) => {
        console.error('Error al cargar usuarios:', err);
      },
    });

    this.Cargarmetas();
    this.initializeFilters();
  }

  metas: any[] = [];
  metasFiltradas: any[] = [];
  all_metas: any[] = [];
  isLoading: boolean = true;
  errorMessage: string = '';
  showRecentDropdown: boolean = false;
  openedMenuId: string | null = null;
  searchTerm: string = '';
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  activeFilters: any = null;

  editStep: number = -1;
  editAmount: number = -1;
  actualAmount: string = '';
  previousAmount: string = '';
  sgtePaso: string = '';
  usuariosSeleccionados = 0;
  showActionsDropdown = false;
  selectedMetaIndex: number | null = null;

  selectedmetas: string[] = [];

  filtroFecha: string = 'nuevo';
  filtroPropietario: string = '';
  usuarios: any[] = [];

  cambiosPorUsuario: Record<string, string> = {};
  readonly DIAS_ESTANCADA = 7;
  readonly DIAS_PROX_CIERRE = 7;
  allMarked = false;

  private diffDias(a: Date, b: Date): number {
    return Math.floor((a.getTime() - b.getTime()) / (1000 * 60 * 60 * 24));
  }

  constructor(
    private api: Api,
    private elementRef: ElementRef,
    private router: Router,
    private alertService: AlertService,
    public permissionService: PermissionService,

  ) {
    this.Cargarmetas();
  }

  readonly dialog = inject(MatDialog);


  private initializeFilters(): void {
    if (!this.activeFilters) {
      this.activeFilters = {
        allStatuses: true,
        allFavorites: true,
        progressRange: 'all',
        dateRange: 'all',
        statuses: {
          sinIniciar: false,
          enCurso: false,
          incompleto: false,
          completado: false
        },
        favorites: {
          marcadas: false,
          noMarcadas: false
        }
      };
    }
  }

  openFilterModal(): void {
    const dialogRef = this.dialog.open(MdlFilterGoals, {
      minWidth: '600px',
      maxHeight: '80vh',
      panelClass: 'mat-dlg-class',
      data: this.activeFilters 
    });

    dialogRef.afterClosed().subscribe((filters: any) => {
      if (filters) {
        this.activeFilters = filters;
        this.applyAdvancedFilters();
        this.alertService.success('Filtros aplicados', 'Filtros aplicados correctamente');
      }
    });
  }

  private applyAdvancedFilters(): void {
    let filteredGoals = [...this.metas];

    if (!this.activeFilters.allStatuses) {
      const selectedStatuses = Object.keys(this.activeFilters.statuses).filter(key => this.activeFilters.statuses[key]);
      if (selectedStatuses.length > 0) {
        filteredGoals = filteredGoals.filter(meta => {
          const goalStatus = this.mapGoalStatusToFilter(meta.estado);
          return selectedStatuses.includes(goalStatus);
        });
      }
    }

    if (!this.activeFilters.allFavorites) {
      if (this.activeFilters.favorites.marcadas && !this.activeFilters.favorites.noMarcadas) {
        filteredGoals = filteredGoals.filter(meta => meta.marcado === 1);
      } else if (this.activeFilters.favorites.noMarcadas && !this.activeFilters.favorites.marcadas) {
        filteredGoals = filteredGoals.filter(meta => meta.marcado === 0);
      }
    }

    
    if (this.activeFilters.progressRange !== 'all') {
      filteredGoals = this.filterByProgressRange(filteredGoals, this.activeFilters.progressRange);
    }

    
    if (this.activeFilters.dateRange !== 'all') {
      filteredGoals = this.filterByDateRange(filteredGoals, this.activeFilters.dateRange);
    }

    this.metasFiltradas = filteredGoals;
    
    if (this.sortColumn) {
      this.applySorting();
    }
  }

  private mapGoalStatusToFilter(estado: string): string {
    const statusMap: { [key: string]: string } = {
      'sin iniciar': 'sinIniciar',
      'en curso': 'enCurso',
      'incompleto': 'incompleto',
      'completado': 'completado'
    };
    
    return statusMap[estado?.toLowerCase()] || estado?.toLowerCase();
  }

  private filterByProgressRange(goals: any[], progressRange: string): any[] {
    return goals.filter(meta => {
      const progress = meta.progreso_actual * 100;
      
      switch (progressRange) {
        case '0-25':
          return progress >= 0 && progress <= 25;
        case '26-50':
          return progress >= 26 && progress <= 50;
        case '51-75':
          return progress >= 51 && progress <= 75;
        case '76-100':
          return progress >= 76 && progress <= 100;
        default:
          return true;
      }
    });
  }

  private filterByDateRange(goals: any[], dateRange: string): any[] {
    const hoy = new Date();
    
    switch (dateRange) {
      case '7d':
        const sieteDiasAdelante = new Date(hoy);
        sieteDiasAdelante.setDate(hoy.getDate() + 7);
        return goals.filter(meta => {
          if (!meta.fecha_fin) return false;
          const fechaFin = new Date(meta.fecha_fin);
          return fechaFin <= sieteDiasAdelante && fechaFin >= hoy;
        });
      
      case '30d':
        const treintaDiasAdelante = new Date(hoy);
        treintaDiasAdelante.setDate(hoy.getDate() + 30);
        return goals.filter(meta => {
          if (!meta.fecha_fin) return false;
          const fechaFin = new Date(meta.fecha_fin);
          return fechaFin <= treintaDiasAdelante && fechaFin >= hoy;
        });
      
      case 'vencidas':
        return goals.filter(meta => {
          if (!meta.fecha_fin) return false;
          const fechaFin = new Date(meta.fecha_fin);
          return fechaFin < hoy && meta.progreso_actual < 1;
        });
      
      default:
        return goals;
    }
  }

  sortByColumn(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.applySorting();
  }

  private applySorting(): void {
    if (!this.sortColumn) return;

    this.metasFiltradas = [...this.metasFiltradas].sort((a, b) => {
      let valueA = a[this.sortColumn];
      let valueB = b[this.sortColumn];

      switch (this.sortColumn) {
        case 'descripcion':
          valueA = valueA?.toLowerCase() || '';
          valueB = valueB?.toLowerCase() || '';
          break;
        
        case 'valor_objetivo':
          valueA = parseFloat(valueA) || 0;
          valueB = parseFloat(valueB) || 0;
          break;
        
        case 'fecha_inicio':
        case 'fecha_fin':
        case 'fecha_actualizacion':
          valueA = valueA ? new Date(valueA) : new Date(0);
          valueB = valueB ? new Date(valueB) : new Date(0);
          break;
        
        case 'progreso_actual':
          valueA = (valueA || 0) * 100;
          valueB = (valueB || 0) * 100;
          break;
        
        case 'estado':
          const priorityA = this.getEstadoPriority(valueA);
          const priorityB = this.getEstadoPriority(valueB);
          return this.sortDirection === 'asc' ? priorityA - priorityB : priorityB - priorityA;
        
        default:
          if (typeof valueA === 'string') {
            valueA = valueA.toLowerCase();
            valueB = valueB.toLowerCase();
          }
      }

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  private getEstadoPriority(estado: string): number {
    switch (estado?.toLowerCase()) {
      case 'completado':
        return 4;
      case 'en curso':
        return 3;
      case 'sin iniciar':
        return 2;
      case 'incompleto':
        return 1;
      default:
        return 0;
    }
  }

  onSearchChange(): void {
    if (!this.searchTerm.trim()) {
      if (this.activeFilters) {
        this.applyAdvancedFilters();
      } else {
        this.metasFiltradas = [...this.metas];
      }
    } else {
      const searchLower = this.searchTerm.toLowerCase().trim();
      this.metasFiltradas = this.metas.filter(meta => 
        meta.descripcion?.toLowerCase().includes(searchLower) ||
        meta.usuario?.nombre?.toLowerCase().includes(searchLower) ||
        meta.usuario?.apellido?.toLowerCase().includes(searchLower) ||
        meta.estado?.toLowerCase().includes(searchLower) ||
        meta.valor_objetivo?.toString().includes(searchLower)
      );
    }
    
    if (this.sortColumn) {
      this.applySorting();
    }
  }

  hasActiveFilters(): boolean {
    if (!this.activeFilters) return false;
    const hasStatusFilter = !this.activeFilters.allStatuses && 
      Object.values(this.activeFilters.statuses).some(val => val === true);
    const hasFavoriteFilter = !this.activeFilters.allFavorites && 
      Object.values(this.activeFilters.favorites).some(val => val === true);
    const hasProgressFilter = this.activeFilters.progressRange !== 'all';
    const hasDateFilter = this.activeFilters.dateRange !== 'all';
    
    return hasStatusFilter || hasFavoriteFilter || hasProgressFilter || hasDateFilter;
  }

  clearFilters(): void {
    this.activeFilters = null;
    this.searchTerm = '';
    this.sortColumn = '';
    this.sortDirection = 'asc';
    this.initializeFilters();
    this.metasFiltradas = [...this.metas];
    this.alertService.success('Filtros limpiados', 'Los filtros han sido limpiados');
  }


  Cargarmetas(): void {
    this.api.showLoading();
    this.isLoading = true;
    this.errorMessage = '';

    this.api.getGoals().subscribe({
      next: (response: any) => {
        const metasArray = Array.isArray(response.metas)
          ? response.metas
          : response;

        this.all_metas = metasArray;
        this.metas = metasArray.map((meta: any) => ({
          ...meta,
          id: meta.meta_id || meta.id,
          marcado: meta.marcado ?? 0,
        }));

        
        if (this.activeFilters) {
          this.applyAdvancedFilters();
        } else {
          this.metasFiltradas = [...this.metas];
        }

        setTimeout(() => {
          this.api.hideLoading();
          this.isLoading = false;
        }, 500);
      },
      error: (error: any) => {
        console.error('Error al cargar Metas:', error);
        this.errorMessage =
          'Error al cargar Metas. Por favor, inténtelo de nuevo más tarde.';
        this.isLoading = false;
        this.api.hideLoading();
      },
    });
  }

  isVencida(fecha: string | Date, meta?: any): boolean {
    if (!fecha) return false;
    const hoy = new Date();
    const fechaFin = new Date(fecha);
    return fechaFin < hoy && (!meta || meta.progreso_actual < 1);
  }

  isProxima(fecha: string | Date): boolean {
    if (!fecha) return false;
    const hoy = new Date();
    const fechaFin = new Date(fecha);
    const diff = (fechaFin.getTime() - hoy.getTime()) / (1000 * 3600 * 24);
    return diff > 0 && diff <= 7;
  }

  isAlcanzadaAntesDeTiempo(fecha: string | Date, meta: any): boolean {
    if (!fecha || meta.estado !== 'Completado') return false;
    const hoy = new Date();
    const fechaFin = new Date(fecha);
    return meta.progreso_actual >= 1 && fechaFin > hoy;
  }

  isAlcanzadaEnFechaLimite(fecha: string | Date, meta: any): boolean {
    if (!fecha || meta.estado !== 'Completado') return false;
    const hoy = new Date();
    const fechaFin = new Date(fecha);
    return (
      meta.progreso_actual >= 1 &&
      fechaFin.toDateString() === hoy.toDateString()
    );
  }

  isSuperada(meta: any): boolean {
    return meta.estado === 'Completado' && meta.progreso_actual > 1;
  }

  esMetaEstancada(meta: any): boolean {
    if (!meta?.usuario_id) return false;
    const iso = this.cambiosPorUsuario[meta.usuario_id];
    if (!iso) return false;
    const last = new Date(iso);
    const hoy = new Date();
    const diasSinCambios = this.diffDias(hoy, last);
    return diasSinCambios > this.DIAS_ESTANCADA && meta.estado !== 'Completado';
  }

  esProximaCerrarSinAvances(meta: any): boolean {
    if (!meta?.fecha_fin) return false;
    if (meta.estado === 'Completado') return false;
    const hoy = new Date();
    const fin = new Date(meta.fecha_fin);
    const diasParaCierre = this.diffDias(fin, hoy);
    return (
      diasParaCierre <= this.DIAS_PROX_CIERRE &&
      diasParaCierre > 0 &&
      this.esMetaEstancada(meta)
    );
  }

  getMetaStatus(meta: any): string {
    if (!meta || !meta.fecha_fin) return 'ninguno';

    if (meta.estancada) return 'estancada';
    if (meta.bajaActividad) return 'baja-actividad';

    if (meta.progreso_actual > 1) return 'superada';

    if (meta.estado === 'Completado' && new Date() < new Date(meta.fecha_fin))
      return 'antes';

    if (this.isProxima(meta.fecha_fin) && meta.sinAvances) return 'sin-avances';

    if (this.isProxima(meta.fecha_fin) && meta.progreso_actual < 1)
      return 'proxima';

    if (this.isVencida(meta.fecha_fin, meta)) return 'vencida';

    return 'ninguno';
  }

  private esUUIDValido(id: string): boolean {
    const regex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return regex.test(id);
  }

  mostrarMensaje(
    mensaje: string,
    tipo: 'exito' | 'error' | 'advertencia'
  ): void {
    switch (tipo) {
      case 'exito':
        this.alertService.success('Éxito', mensaje);
        break;
      case 'error':
        this.alertService.error('Error', mensaje);
        break;
      case 'advertencia':
        this.alertService.warning('Advertencia', mensaje);
        break;
    }
  }

  openMdlCreateGoal() {
    this.dialog.open(MdlManageGoals, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'create',
      },
    }).afterClosed().subscribe(result => {
      if (result) {
        this.Cargarmetas();
      }
    });
  }

  openMdlUpdateGoal(data: any) {
    this.dialog.open(MdlManageGoals, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'edit',
        meta: data,
      },
    });
  }

  openmdldeleteGoal(id: string): void {
    const dialogRef = this.dialog.open(MdlDelete, {
      minWidth: '400px',
      maxHeight: '600px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'goals',
        ids: [id],
      },  
    });
  }

updateMarca(id: string) {
  const metaIndex = this.metas.findIndex(m => m.meta_id === id);
  if (metaIndex === -1) return;

  // Cambia el valor localmente
  const nuevoValor = this.metas[metaIndex].marcado === 0 ? 1 : 0;
  this.metas[metaIndex].marcado = nuevoValor;

  // Sincroniza en all_metas
  const indexAll = this.all_metas.findIndex(m => m.meta_id === id);
  if (indexAll !== -1) this.all_metas[indexAll].marcado = nuevoValor;

  // Sincroniza también en metasFiltradas
  const indexFiltrado = this.metasFiltradas.findIndex(m => m.meta_id === id);
  if (indexFiltrado !== -1) this.metasFiltradas[indexFiltrado].marcado = nuevoValor;

  // Llama al backend
  this.api.markGoal({ meta_id: id, marcado: nuevoValor }).subscribe({
    next: () => console.log(`Meta ${id} marcada = ${nuevoValor}`),
    error: err => console.error('Error al marcar meta:', err),
  });
}


checkMarkedGoals() {
  if (!Array.isArray(this.all_metas) || this.all_metas.length === 0) {
    console.warn('No hay metas cargadas para filtrar.');
    return;
  }

  this.allMarked = !this.allMarked;

  if (this.allMarked) {
    this.metasFiltradas = this.all_metas.filter(m => m.marcado === 1);
  } else {
    // 👇 Respeta el orden actual de metas (sin “reset”)
    this.metasFiltradas = [...this.metas];
  }
}


  toggleActionsDropdown() {
    this.showActionsDropdown = !this.showActionsDropdown;
  }

  ejecutarAccion(accion: string) {
    console.log(`Acción ejecutada: ${accion}`);
    this.showActionsDropdown = false;

    if (accion === 'eliminar') {
      if (this.selectedmetas.length === 0) {
        console.warn('No hay metas seleccionadas para borrar');
        return;
      }

      const dialogRef = this.dialog.open(MdlDelete, {
        minWidth: '400px',
        maxHeight: '600px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'goals',
          ids: this.selectedmetas,
        },
      });
    }

    if (accion === 'desactivar') {
    }

    if (accion === 'activar') {
    }
  }

  onCheckboxChange(event: any, metaId: string) {
    if (event.target.checked) {
      this.selectedmetas.push(metaId);
    } else {
      this.selectedmetas = this.selectedmetas.filter((id) => id !== metaId);
    }

    this.usuariosSeleccionados = this.selectedmetas.length;
  }

  getPopoverClass(meta: any): string {
    switch (this.getMetaStatus(meta)) {
      case 'superada':
        return 'superada';
      case 'antes':
        return 'success';
      case 'proxima':
        return 'warning';
      case 'sin-avances':
        return 'warning';
      case 'baja-actividad':
        return 'warning';
      case 'estancada':
        return 'danger';
      case 'vencida':
        return 'danger';
      default:
        return '';
    }
  }

  getPopoverTitle(meta: any): string {
    switch (this.getMetaStatus(meta)) {
      case 'superada':
        return 'Meta superada';
      case 'antes':
        return 'Meta alcanzada antes de tiempo';
      case 'proxima':
        return 'Meta próxima a vencer';
      case 'sin-avances':
        return 'Meta próxima al cierre sin avances';
      case 'baja-actividad':
        return 'Aviso por baja actividad';
      case 'estancada':
        return 'Meta estancada';
      case 'vencida':
        return 'Meta atrasada';
      default:
        return 'Meta en progreso';
    }
  }

  getPopoverMessage(meta: any): string {
    switch (this.getMetaStatus(meta)) {
      case 'superada':
        return `fue superada. Resultado: ${meta.valor_objetivo}.`;
      case 'antes':
        return `se alcanzó ${this.diasAntes(
          meta.fecha_fin
        )} días antes del fin del periodo.`;
      case 'proxima':
        return `finaliza en ${this.diasRestantes(meta.fecha_fin)} días.`;
      case 'sin-avances':
        return `finaliza en ${this.diasRestantes(
          meta.fecha_fin
        )} días y no se ha registrado avances en los últimos 7 días.`;
      case 'baja-actividad':
        return meta.diasSinActividad
          ? `no presenta movimientos desde hace ${meta.diasSinActividad} días.`
          : 'no presenta movimientos recientes.';
      case 'estancada':
        return meta.fechaEstancada
          ? `mantiene el mismo progreso desde el ${new Date(
              meta.fechaEstancada
            ).toLocaleDateString('es-CL')}.`
          : 'mantiene el mismo progreso desde hace varios días.';
      case 'vencida':
        return `finalizó hace ${this.diasPasados(meta.fecha_fin)} días.`;
      default:
        return 'está en curso.';
    }
  }

  goToGoalsGraphic() {
    this.router.navigate(['/goals-graphic']);
  }

  diasAntes(fecha: string | Date): number {
    const hoy = new Date();
    const fechaFin = new Date(fecha);
    const diff = (fechaFin.getTime() - hoy.getTime()) / (1000 * 3600 * 24);
    return Math.max(Math.floor(diff), 0);
  }
  diasRestantes(fecha: string | Date): number {
    return this.diasAntes(fecha);
  }

  diasPasados(fecha: string | Date): number {
    const hoy = new Date();
    const fechaFin = new Date(fecha);
    const diff = (hoy.getTime() - fechaFin.getTime()) / (1000 * 3600 * 24);
    return Math.max(Math.floor(diff), 0);
  }

  closePopover(event: Event) {
    event.stopPropagation();
    this.selectedMetaIndex = null;
  }

  refrescarMetas() {
    this.api.showLoading();
    this.Cargarmetas();
  }

filtrarMetas() {
  let resultado = [...this.all_metas];

  if (this.filtroPropietario) {
    resultado = resultado.filter(meta => meta.usuario_id === this.filtroPropietario);
  }

  if (this.filtroFecha === 'nuevo') {
    resultado.sort((a, b) => new Date(b.fecha_fin).getTime() - new Date(a.fecha_fin).getTime());
  } else if (this.filtroFecha === 'antiguo') {
    resultado.sort((a, b) => new Date(a.fecha_fin).getTime() - new Date(b.fecha_fin).getTime());
  }

  this.metas = resultado;
  this.metasFiltradas = [...resultado];
}


  esProximaAVencer(meta: any): boolean {
    if (!meta || !meta.fecha_fin) return false;
    if (meta.progreso_actual >= 1) return false;

    const hoy = new Date();
    const fechaFin = new Date(meta.fecha_fin);
    const diff = (fechaFin.getTime() - hoy.getTime()) / (1000 * 3600 * 24);

    return diff > 0 && diff <= 7;
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null): void {
    if (!(target instanceof HTMLElement)) return;

    const clickedInsideRecent = this.elementRef.nativeElement
      .querySelector('.dropdown-trigger')
      ?.contains(target);
    const clickedInsideActions = this.elementRef.nativeElement
      .querySelector('.dots-button')
      ?.contains(target);

    if (!clickedInsideRecent) {
      this.showRecentDropdown = false;
    }

    if (!clickedInsideActions) {
      this.openedMenuId = null;
    }
  }
}